export const notesFilePath = ({fileName})=>{
    return `/forms/${Date.now()}-${fileName?.replace(/\s/g, '')}`
}